import { useTranslation } from 'hooks/useTranslation'
import CredentialsForm, {
  CredentialsFormValues
} from 'modules/authentication/components/CredentialsForm'
import useAuthenticationContext from 'modules/authentication/hooks/useAuthenticationContext'
import usePasswordRequestContext from 'modules/passwordRequest/hooks/usePasswordRequestContext'
import { useNavigate } from 'react-router'
import { TokenTypeEnum } from 'services/api/iam/manager/enums/TokenTypeEnum'
import { useLoggingIn, useLogin } from 'services/api/iam/manager/mutations/useLogin'

export default function LoginForm() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    email: [, setEmail],
    errorRequestPassword: [errorRequestPassword]
  } = usePasswordRequestContext()
  const {
    token: [, setToken]
  } = useAuthenticationContext()
  const {
    mutateAsync,
    error: errorLogin,
    isError: isErrorLogin
  } = useLogin({
    onSuccess: data => {
      setToken(data)
      switch (data.type) {
        case TokenTypeEnum.AUTH:
          navigate('/choose-account')
          break
        case TokenTypeEnum.TWO_FACTOR_AUTH:
          navigate('/2fa')
          break
      }
    }
  })
  const isLoading = useLoggingIn()
  const error = isErrorLogin
    ? t(errorLogin.response?.data.code || errorLogin.message)
    : errorRequestPassword
    ? t(errorRequestPassword)
    : undefined
  const submit = async ({ email, password }: CredentialsFormValues) => {
    await mutateAsync({ username: email, password }).catch(() => undefined)
  }
  const recover = (email: string) => {
    setEmail(email)
    navigate('/register-new-password')
  }

  return (
    <CredentialsForm
      busy={isLoading}
      error={error}
      submitLabel={t('Entrar')}
      validateEmailOnSubmit={false}
      onSubmit={submit}
      onRecover={recover}
    />
  )
}
